module.exports = __webpack_public_path__ + "media/images/logo_white-263a223e726e525cf88e2cac995d72cc.svg";